import { AboveGradeWallType, BelowGradeWallType } from 'data/types';
import { normalizeOpeningOnWall } from 'utils/opening-position';
import { OpeningRunBoundsType } from 'utils/opening-position-types';

export function resizeWindowOnWalls<
  T extends AboveGradeWallType | BelowGradeWallType
>(
  walls: T[],
  wallMatches: (wall: T) => boolean,
  windowId: string,
  newWidth: number,
  newHeight: number,
  runBounds: OpeningRunBoundsType
): T[] {
  return walls.map((wall) => {
    if (!wallMatches(wall)) {
      return wall;
    }

    return {
      ...wall,
      verticalGlass: wall.verticalGlass?.map((glass) =>
        glass.uniqueId === windowId
          ? normalizeOpeningOnWall(
              { ...glass, width: newWidth, height: newHeight },
              runBounds
            )
          : glass
      )
    };
  });
}
